module.exports = __webpack_public_path__ + "img/9788925553313.b7c6ce92.jpg";